const errorComponent = () => import(/* webpackChunkName: "views/error" */ '../views/Error');


export default [
  {
    path: '/',
    name: 'landingPage',
    component: () => import(/* webpackChunkName: "views/landingpage" */ '../views/LandingPage')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "views/about" */ '../views/About'),
    meta: {
      permissions: ['user']
    }
  },
  {
    path: '/error',
    name: 'error',
    component: errorComponent,
    props: {
      status: 404,
      title: 'error.404.title',
      message: 'error.404.message'
    }
  },
  {
    path: '/403',
    name: '403',
    component: errorComponent,
    props: {
      status: 403,
      title: 'error.403.title',
      message: 'error.403.message'
    }
  },
  {
    path: '/500',
    name: '500',
    component: errorComponent,
    props: {
      status: 500,
      title: 'error.500.title',
      message: 'error.500.message'
    }
  },
  {
    path: '*',
    name: '404',
    component: errorComponent,
    props: {
      status: 404,
      title: 'error.404.title',
      message: 'error.404.message'
    }
  }
];
